import { getRaw, postRaw } from 'services/api';
import {
  fetchMockDashboard,
  fetchMockDashboardData,
  saveMockDashboard,
} from './mock/DashboardMockAPI';

export const USE_MOCK_ID = 'iterableDashboardUseMock';
export const FETCH_CAMPAIGNS_URL = '/campaigns.json';
export const FETCH_DASHBOARD_URL = '/i/dashboards/user';
export const SAVE_DASHBOARD_URL = '/i/dashboards/user';
export const FETCH_DASHBOARD_DATA_URL = '/i/dashboards/getMetricsData';

/**
 * useMock
 * Determines to use mock API or not.
 * @returns { Boolean } If localStorage is used.
 */
export const useMock = () => {
  if (window.localStorage) {
    return window.localStorage.getItem(USE_MOCK_ID) === 'true';
  }
  return false;
};

/**
 * toggleLocalStorage
 * Toggles the use of API and localStorage.
 * @returns { String } Toggle mode message.
 */
export const toggleDashboardMock = () => {
  if (window.localStorage) {
    const current = localStorage.getItem(USE_MOCK_ID);
    if (current === 'true') {
      localStorage.setItem(USE_MOCK_ID, 'false');
      return 'Using Iterable Dashboard API. Please Refresh Page.';
    }
    localStorage.setItem(USE_MOCK_ID, 'true');
    return 'Using Dashboard Mock API. Please Refresh Page.';
  }
  return '';
};

/**
 * fetchCampaigns
 * Fetches dashboard data containing widgets and settings.
 * @param { Object } params: Fetch paramters for campaigns.
 * @returns { Promise } Fetched dashboard data.
 */
export const fetchCampaigns = (params) => getRaw(FETCH_CAMPAIGNS_URL, { params });

/**
 * fetchDashboard
 * Fetches dashboard data containing widgets and settings.
 * @returns { Promise } Fetched dashboard data.
 */
export const fetchDashboard = () =>
  useMock() ? fetchMockDashboard() : getRaw(FETCH_DASHBOARD_URL);

/**
 * fetchDashboardData
 * Fetches data for a particular dashboard widget.
 * @param { Object } props: Fetch props for getting data for a widget.
 *  {
 *    @param { Object } metric: The metric of the widget.
 *    @param { String } dataType: The type of data to fetch for. (e.g. 'series', 'sum').
 *    @param { String } startTime: The start range date/time to fetch data for.
 *    @param { String } endTime: The end range date/time to fetch data for.
 *  }
 * @returns { Promise } Fetched dashboard widget data.
 */
export const fetchDashboardData = ({ metric, dataType, startTime, endTime }) =>
  useMock()
    ? fetchMockDashboardData({ metric, dataType, startTime, endTime })
    : postRaw(FETCH_DASHBOARD_DATA_URL, { metric, dataType, startTime, endTime });

/**
 * saveDashboard
 * Saves dashboard data.
 * @param { Object } dashboardData: Dashboard widgtes and settings to save.
 * @returns { Promise } Reponse status of save.
 */
export const saveDashboard = (dashboardData) =>
  useMock() ? saveMockDashboard(dashboardData) : postRaw(SAVE_DASHBOARD_URL, dashboardData);
